var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19995 3.44176C2.19995 2.64571 2.86164 2 3.67791 2H20.722C21.5382 2 22.1999 2.64571 22.1999 3.44176V20.6851C22.1999 21.4814 21.5382 22.1269 20.722 22.1269H3.67791C2.86164 22.1269 2.19995 21.4814 2.19995 20.6851V3.44176ZM8.26257 18.8482V9.7598H5.24175V18.8482H8.26257ZM6.75215 8.51893C7.80557 8.51893 8.46124 7.82104 8.46124 6.94888C8.44161 6.05709 7.80557 5.37857 6.77213 5.37857C5.7388 5.37857 5.06318 6.05709 5.06318 6.94888C5.06318 7.82104 5.71871 8.51893 6.73246 8.51893H6.75209H6.75215ZM12.9548 18.8482H9.93414C9.93414 18.8482 9.97378 10.6126 9.93414 9.7598H12.9549V11.0465C12.9481 11.0571 12.9414 11.0675 12.9348 11.0779H12.9549V11.0465C13.3564 10.4273 14.0749 9.54654 15.6773 9.54654C17.6648 9.54654 19.1551 10.8455 19.1551 13.637V18.8482H16.1345V13.9861C16.1345 12.7644 15.6973 11.9309 14.6042 11.9309C13.7697 11.9309 13.2726 12.493 13.0542 13.0357C12.9745 13.2299 12.9548 13.5012 12.9548 13.7729V18.8482Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.df8b9c2f1436582cf94a7356f876c861.svg";
export { ForwardRef as ReactComponent };